import { render, staticRenderFns } from "./OverallSalesByWeekNested.vue?vue&type=template&id=b0f4ff1c&scoped=true"
import script from "./OverallSalesByWeekNested.vue?vue&type=script&lang=js"
export * from "./OverallSalesByWeekNested.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f4ff1c",
  null
  
)

export default component.exports